module.exports = __webpack_public_path__ + "img/logo-depotest.5ffeb19e.png";